///
/// EarthBrowser
///
/// Migration: v26 -> v27
/// Enables the wildfire perimeter dataset by default
///
/// Created by Matt Giger on 9/5/2026
/// Copyright (c) 2026 Geodata Labs
///

interface StateV26 {
	earthbrowser?: {
		visibleDatasets?: string[]
	}
}

/**
 * Migration from version 26 to 27: Add wildfire dataset support
 * - Adds "wildfire" to visibleDatasets so live fire perimeters show by
 *   default (matching earthquakes/volcanoes as default-on hazard layers)
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV26toV27(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV26
	const oldEarthbrowser = s.earthbrowser || {}

	const visibleDatasets = Array.isArray(oldEarthbrowser.visibleDatasets)
		? [...oldEarthbrowser.visibleDatasets]
		: ["cloud", "earthquake", "satellite", "aurora", "volcano"]

	if (!visibleDatasets.includes("wildfire")) {
		visibleDatasets.push("wildfire")
	}

	return {
		...s,
		earthbrowser: {
			...oldEarthbrowser,
			visibleDatasets,
		}
	}
}
